import axios from "axios";
import { API_URL } from "@/config";
import { Toast } from "vant";
import { getCookie } from "@/libs/utils";
import CryptoJS from "crypto-js";
import { toLogin } from "@/bridge/AppJsBridge";
import { getCurrentHost } from "@/libs/boxHost";


const transformObjToStr = (obj = {}) => {
  return JSON.stringify(obj) + 'ksform3876ud'
}

export const md5Str = (str) => {
  return CryptoJS.MD5(str).toString().toLowerCase()
}

class HttpRequest {
  getInsideConfig() {
    const config = {
      baseURL: API_URL,
      headers: {},
      method: "post", //  默认请求方式为post,其他方式需调request时另写
    };
    return config;
  }
  interceptors(instance) {
    // 请求拦截
    instance.interceptors.request.use(
      (config) => {
        const base = getCurrentHost(config)
        if (base) {
          config.baseURL = base;
        }
        if (config.requireToken) {
          const token = localStorage.getItem("token") || getCookie("token") || "";
          config.headers.token = token;
          config.headers.Authorization = token;
        }
        if (config.useTemp) {
          const tempId = localStorage.getItem("tempId") || 0;
          config.headers["template-id"] = tempId;
        }

        // 快手表单 统一处理 sign
        if (config.requireKsFormSign) {
          config.headers["CloudType"] = 4
          if (!config.headers.CloudSign) {
            const source_sign = transformObjToStr(config.data)
            config.headers["CloudSign"] = md5Str(source_sign)
          }
        }

        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
    // 响应拦截
    instance.interceptors.response.use(
      (res) => {
        const { data, status, config } = res;
        if (status === 200) {
          if (data.ret === 1 || data.code === 0) {
            return data;
          } else {
            if ((data.msg || data.message) && !config.unHint) {
              Toast.fail({
                message: data.msg || data.message,
                duration: 2000,
              });
            }
            return Promise.reject(data);
          }
        }
      },
      (error) => {
        let errorInfo = error.response;
        if (error.response.status === 404 && error.config.requireToken) {
          Toast.fail({
            message: "活动已结束，感谢您的参与",
            duration: 2000,
          });
        }
        if (!errorInfo) {
          const {
            request: { statusText, status },
            config,
          } = JSON.parse(JSON.stringify(error));
          errorInfo = {
            statusText,
            status,
            request: {
              responseURL: config.url,
            },
          };
        } else {
          if (errorInfo.data.code === 401 && error.config.requireLogin) {
            console.log('go login')
            toLogin("/loginKey/LoginByKeyPhoneActivity");
          }
        }
        return Promise.reject(error);
      }
    );
  }
  request(options) {
    const instance = axios.create();
    options = Object.assign(this.getInsideConfig(), options);
    // 本地不同服务对应不同接口
    // if (options.url === '/wx-box-active/vip/activity/list') {
    //   options.baseURL = '//172.16.28.40:10063'
    // }
    // if (options.url === '/wx-box-user/user/check') {
    //   options.baseURL = '//172.16.28.40:10061'
    // }
    this.interceptors(instance);
    return instance(options);
  }
  // 上传图片单独使用
  // upload() {
  //   const instance = axios.create({
  //     headers:{'Content-Type':'multipart/form-data'},
  //   })
  //   return instance;
  // }
}
export default HttpRequest;
